<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Rulegroup') : $t('New Rulegroup')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.name"
              label="Name"
              v-validate="'required'"
              required
              data-vv-name="name"
              :error-messages="errors.collect('name')"
            ></v-text-field>
            <v-data-table
              :headers="headers"
              :items="formValues.rules"
              :loading="loading"
              :multi-sort="true"
              class="elevation-1"
              hide-default-footer
              :footer-props="{
                'items-per-page-options': [10, 15, 50, -1]
              }"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <h4 class="pt-5 pb-0">{{ $t("Rules") }}</h4>
                  <v-spacer></v-spacer>
                  <v-btn color="red lighten-2" dark @click="dialog = true">
                    {{ $t("Add Rule") }}
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:item.edit="{ item }">
                <v-icon small color="red" class="mr-2" @click="editValue(item)">
                  mdi-pencil
                </v-icon>
              </template>
              <template v-slot:item.delete="{ item }">
                <v-icon
                  small
                  color="red"
                  class="mr-2"
                  @click="removeValue(item)"
                >
                  mdi-minus-circle-outline
                </v-icon>
              </template>
            </v-data-table>
            <v-dialog v-model="dialog" eager>
              <base-material-card
                color="primary"
                icon="mdi-account"
                :title="rule.id ? $t('Edit rule') : $t('Add rule')"
                class="px-5 py-3"
              >
                <v-form
                  ref="form"
                  autocomplete="new-password"
                  lazy-validation
                  @submit.prevent="addValue"
                >
                  <v-select
                    v-model="rule.dimension"
                    :items="['width', 'height']"
                    label="Dimension"
                    data-vv-name="dimension"
                    :error-messages="errors.collect('dimension')"
                  ></v-select>
                  <v-text-field
                    v-model="rule.dimension_min"
                    type="number"
                    label="Min dimension"
                    v-validate=""
                    data-vv-name="dimension_min"
                    :error-messages="errors.collect('dimension_min')"
                  ></v-text-field>
                  <v-text-field
                    v-model="rule.dimension_max"
                    type="number"
                    label="Max dimension"
                    v-validate=""
                    data-vv-name="dimension_max"
                    :error-messages="errors.collect('dimension_max')"
                  ></v-text-field>
                  <v-text-field
                    v-model="rule.other_dimension_reference_value"
                    type="number"
                    label="Other dimension reference value"
                    v-validate=""
                    data-vv-name="other_dimension_reference_value"
                    :error-messages="
                      errors.collect('other_dimension_reference_value')
                    "
                  ></v-text-field>
                  <v-text-field
                    v-model="rule.divergence_percentage"
                    label="Divergence percentage"
                    type="number"
                    v-validate="'required|min_value:0'"
                    data-vv-name="divergence_percentage"
                    :error-messages="errors.collect('divergence_percentage')"
                  ></v-text-field>

                  <v-card-actions class="pl-0">
                    <v-btn color="primary" class="mr-4" @click="dialog = false">
                      {{ $t("back") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="mr-4" @click="addValue">
                      {{ $t("save") }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </base-material-card>
            </v-dialog>

            <v-alert type="error" v-for="item in errors.items" :key="item">
              {{ item.msg }}
            </v-alert>

            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'ruleGroup.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem } from "../shared/services";
export default {
  name: "app-ruleGroup-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        rules: []
      },
      loading: true,
      rule: {
        dimension: null,
        dimension_min: 0,
        dimension_max: 0,
        other_dimension_reference_value: null,
        divergence_percentage: 0
      },
      headers: [
        { text: "Dimension", value: "dimension" },
        { text: "Min dimension", value: "dimension_min" },
        { text: "Max dimension", value: "dimension_max" },
        {
          text: "Other dimension reference value",
          value: "other_dimension_reference_value"
        },
        { text: "Divergence percentage", value: "divergence_percentage" },
        { value: "edit" },
        { value: "delete" }
      ],
      dialog: false
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async addValue() {
      if (!this.rule.id) {
        this.formValues.rules.push(this.rule);
      }
      this.dialog = false;
      this.initRule();
    },
    initRule() {
      this.rule = {
        dimension: 0,
        dimension_min: 0,
        dimension_max: 0,
        other_dimension_reference_value: null,
        divergence_percentage: 0
      };
    },
    editValue(item) {
      this.rule = item;
      this.dialog = true;
    },
    removeValue(item) {
      this.formValues.rules = this.formValues.rules.filter(
        rule => rule != item
      );
    },
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "ruleGroup.index" });
      }
    }
  },
  watch: {
    item_dialog: {
      handler(val) {
        if (!val) this.initRule();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
